import React from 'react';
import styles from '../../styles/modules/components/cross-sell.module.scss';
import Section from '../common/Section';
import Button from '../common/ui-components/input/Button';
import Hidden from '@mui/material/Hidden';
import Slider from 'react-slick';
import { NextArrow, PrevArrow } from '../common/ui-components/carosel';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import theme from '../mui-overrides';
import { crosssellCarouselClicked } from '../../tracking/segment/planPage';

interface MainProps {
    list: {
        title: string,
        descriptions: any[],
        target_url: string
    }[],
    router: any,
    category?: any
}

interface ItemsProps {
    title: string,
    descriptions: any[],
    target_url: string,
    router: any,
    key:any,
    category?:any
}

// const props = {
//     'title': 'Doorstep InstaRepair services for your Water Purifier',
//     'description': ['Complete door-to-door repair service', '24*7 helpline to solve all your questions regarding your appliance repair'],
//     'url': 'url'
// }

const CrossSell = (props: MainProps) => {

    // Slider Styles in global.modules.scss
    const settings = {
        slidesToShow: 1,
        dots: true,
        speed: 800,
        slidesToScroll: 1,
        infinite: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 2500,
    }
    let content = <></>;
    if(props.list.length > 0){
        content = <Section className={`${styles.contains} cross-sell`} title={'Other Recommended Services'} subtitle={'SERVICES'} hasPadding={true}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <Hidden key='mobile' mdUp>
                        <div className='container'>
                            {
                                props.list.map((item, index) => {
                                    return <CrossSellCard key={index} title={item.title} descriptions={item.descriptions} target_url={item.target_url} router={props.router} category={props.category}/>;
                                })
                            }
                        </div>
                    </Hidden>
                    <Hidden key='web' mdDown>
                        <div className="container">
                            <Slider {...settings}>
                                {
                                    props.list.map((item, index) => {
                                        return <CrossSellCard key={index} title={item.title} descriptions={item.descriptions} target_url={item.target_url} router={props.router} category={props.category}/>;
                                    })
                                }
                            </Slider>
                        </div>
                    </Hidden>
                </ThemeProvider>
            </StyledEngineProvider>
        </Section>
    }
    return content;
}

const CrossSellCard = (props: ItemsProps) => {
    return (
        <div className={styles._card}>
            <h2>{props.title}</h2>
            <ul>
                {props.descriptions.map((item, index) => <li key={index}>{item}</li>)}
            </ul>
            <div className={styles._btn}>
                <Button className={styles._btn_submit} text="Explore Plans" onClick={(e) => {
                    e.preventDefault()
                    props.router.push(`/${props.target_url}`)
                    window.scrollTo(0, 0);
                    crosssellCarouselClicked({'card_title':props.title, 'cta_url':props.target_url, 'cta_name':'Explore Plans','category':props.category})
                }} />
            </div>
        </div>

    )

}

export default CrossSell
